/**
 * Reusable stateless form component for Transition
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { SelectFromObject } from '../../../global/components/forms';

function TransitionForm({
  cancelLink
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , nodeStore
  , transition
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Transition" : "Update Transition";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  // SelectFromObject arrays
  // TODO: restrict this sponsors list to only be for a matching sponsor - do in other forms also!
  let nodesArray = nodeStore ? nodeStore.util.getList() : [];
  nodesArray = nodesArray && nodesArray.length > 0 ? nodesArray : [];

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="transitionForm" className="transition-form" onSubmit={handleFormSubmit}>
            {header}
            <SelectFromObject
              change={handleFormChange}
              display={'_id'}
              label="Start Node"
              name="_startNode"
              objects={nodesArray}
              placeholder="-- Select a Start Node --"
              required={true}
              selected={transition._startNode}
              value={'_id'}
            />
            <SelectFromObject
              change={handleFormChange}
              display={'_id'}
              label="End Node"
              name="_endNode"
              objects={nodesArray}
              placeholder="-- Select an End Node --"
              required={true}
              selected={transition._endNode}
              value={'_id'}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

TransitionForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , nodeStore: PropTypes.object.isRequired
  , transition: PropTypes.object.isRequired
}

TransitionForm.defaultProps = {
  formTitle: ''
}

export default TransitionForm;



// WEBPACK FOOTER //
// modules/transition/components/TransitionForm.js.jsx